import * as React from 'react';
import useStyles from './Auth0Footer.styles';
import { Trans } from '@lingui/react';
import { CustomCiamUiTheme } from '../../../theme';
import { useTheme } from 'react-jss';

export interface IAuth0FooterProps {
  privacyLink: string;
  termsOfUseLink: string;
}

const Auth0Footer: React.FC<IAuth0FooterProps> = ({
  privacyLink,
  termsOfUseLink,
}) => {
  const theme = useTheme<CustomCiamUiTheme>();
  const classes = useStyles({ theme });
  return (
    <div className={classes.root}>
      <Trans
        id="By clicking Log In, you agree to our <0>Align Terms</0>. For more information about how Align handles your data, please read our <1>Privacy Policy</1>."
        components={{
          0: <a className={classes.link} href={termsOfUseLink} />,
          1: <a className={classes.link} href={privacyLink} />,
        }}
      />
    </div>
  );
};

export default Auth0Footer;
